export default function ToastServiceProvider() {
  this.$get = ($rootScope, $compile, $document, $q, $timeout, $animate, $controller) => {
    'ngInject';

    function ToastServiceProvider() {

      const self = this;

      const queue = [];
      let activeToast = null;
      let activeDeferred = null;
      let hideTimer = null;

      const containers = Object.create(null);
      const defaultParent = $document.find('body');

      const VALID_POSITIONS = {top: true, bottom: true, left: true, right: true, center: true};

      const normalizePosition = position => {
        const result = {vertical: 'bottom', horizontal: 'center'};
        if (!position) {
          return result;
        }

        position.split(/\s+/).forEach(pos => {
          if (!VALID_POSITIONS[pos]) {
            return;
          }

          if (pos === 'top' || pos === 'bottom') {
            result.vertical = pos;
          }

          if (pos === 'left' || pos === 'right' || pos === 'center') {
            result.horizontal = pos;
          }
        });

        return result;
      }

      const positionClasses = pos => 'vui-toast-' + pos.vertical + ' vui-toast-' + pos.horizontal;

      const containerKey = pos => pos.vertical + '-' + pos.horizontal;

      const getContainer = pos => {
        const key = containerKey(pos);

        if (!containers[key]) {
          const el = angular.element(
            '<div class="vui-toast-container ' + positionClasses(pos) + '"></div>'
          );
          $document.find('body').prepend(el);
          containers[key] = {element: el, count: 0};
        }

        containers[key].count++;
        return containers[key];
      }

      const releaseContainer = pos => {
        const key = containerKey(pos);
        const container = containers[key];

        if (!container) {
          return;
        }

        container.count--;
        if (container.count === 0) {
          container.element.remove();
          delete containers[key];
        }
      }

      const createScope = locals => {
        const scope = $rootScope.$new(true);
        angular.forEach(locals || {}, (value, key) => scope[key] = value);
        return scope;
      }

      const initController = (options, scope) => {
        if (!options.controller) {
          return;
        }

        const locals = angular.extend({}, options.locals || {}, {$scope: scope});
        const ctrl = $controller(options.controller, locals, null, options.controllerAs);

        if (options.controllerAs) {
          scope[options.controllerAs] = ctrl;
        }
      }

      const compileTemplate = (options, scope) => {
        const tpl = options.templateUrl
          ? '<vui-toast class="vui-toast" ng-include="\''
          + options.templateUrl + '\'"></vui-toast>'
          : '<vui-toast class="vui-toast">' + (options.template || '') + '</vui-toast>';
        return $compile(tpl)(scope);
      }

      const processQueue = () => {
        if (activeToast || queue.length === 0) {
          return;
        }

        const item = queue.shift();
        const opts = item.options;
        activeDeferred = item.deferred;

        const scope = createScope(opts.locals);
        initController(opts, scope);

        const pos = normalizePosition(opts.position);
        const container = getContainer(pos);
        const element = compileTemplate(opts, scope);

        activeToast = {element: element, scope: scope, position: pos};

        $animate.enter(element, container.element);

        if (opts.hideDelay > 0) {
          hideTimer = $timeout(self.hide, opts.hideDelay);
        }
      }

      const cleanup = () => {
        if (!activeToast) {
          return $q.resolve();
        }

        if (hideTimer) {
          $timeout.cancel(hideTimer);
          hideTimer = null;
        }

        const toast = activeToast;
        activeToast = null;

        return $animate.leave(toast.element).then(() => {
          toast.scope.$destroy();
          releaseContainer(toast.position);
        });
      }

      self.show = options => {
        options = angular.extend({
          template: '',
          hideDelay: 3000,
          position: 'bottom center',
          parent: defaultParent
        }, options);

        const deferred = $q.defer();
        queue.push({options: options, deferred: deferred});
        processQueue();
        return deferred.promise;
      }

      self.hide = () => {
        if (!activeToast) {
          return;
        }

        cleanup().then(() => {
          if (activeDeferred) {
            activeDeferred.resolve();
            activeDeferred = null;
          }
          processQueue();
        });
      }

      self.cancel = () => {
        if (!activeToast) {
          return;
        }
        cleanup().then(() => {
          if (activeDeferred) {
            activeDeferred.reject('cancelled');
            activeDeferred = null;
          }
          processQueue();
        });
      }

      self.cancelAll = () => {
        const promises = [];
        if (activeToast) {
          promises.push(cleanup().then(() => {
            if (activeDeferred) {
              activeDeferred.reject('cancelled');
              activeDeferred = null;
            }
          }));
        }
        queue.forEach(item => item.deferred.reject('cancelled'));
        queue.length = 0;
        return $q.all(promises);
      }

      self.destroy = () => {};
    }

    return new ToastServiceProvider();
  };
}